/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * Delivery of the latest fax sent to this recipient. Absent when the recipient was never faxed. A resend replaces it.
 * @export
 * @interface RecipientFaxDelivery
 */
export interface RecipientFaxDelivery {
    /**
     * 
     */
    status: RecipientFaxDeliveryStatusEnum;
    /**
     * Readable failure reason. Null unless the fax failed.
     */
    reason: string | null;
    /**
     * 
     */
    fax_number: string | null;
    /**
     * 
     */
    updated_at: Date;
}


/**
 * @export
 */
export const RecipientFaxDeliveryStatusEnum = {
    Sending: 'sending',
    Delivered: 'delivered',
    Failed: 'failed',
} as const;
export type RecipientFaxDeliveryStatusEnum = typeof RecipientFaxDeliveryStatusEnum[keyof typeof RecipientFaxDeliveryStatusEnum];


/**
 * Check if a given object implements the RecipientFaxDelivery interface.
 */
export function instanceOfRecipientFaxDelivery(value: object): value is RecipientFaxDelivery {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    if (!('fax_number' in value) || value['fax_number'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    return true;
}

export function RecipientFaxDeliveryFromJSON(json: any): RecipientFaxDelivery {
    return RecipientFaxDeliveryFromJSONTyped(json, false);
}

export function RecipientFaxDeliveryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecipientFaxDelivery {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'reason': json['reason'],
        'fax_number': json['fax_number'],
        'updated_at': (json['updated_at'] == null ? json['updated_at'] : parseDateTime(json['updated_at'])),
    };
}

export function RecipientFaxDeliveryToJSON(json: any): RecipientFaxDelivery {
    return RecipientFaxDeliveryToJSONTyped(json, false);
}

export function RecipientFaxDeliveryToJSONTyped(value?: RecipientFaxDelivery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'reason': value['reason'],
        'fax_number': value['fax_number'],
        'updated_at': value['updated_at'] == null ? value['updated_at'] : serializeDateTime(value['updated_at']),
    };
}

